import React from 'react';
import './index.css';
import idle1 from './images/dino/Idle (1).png'; //https://pzuh.itch.io/free-dino-sprites
import idle2 from  './images/dino/Idle (2).png'; //https://pzuh.itch.io/
import idle3 from  './images/dino/Idle (3).png';
import idle4 from './images/dino/Idle (4).png';
import idle5 from  './images/dino/Idle (5).png';
import idle6 from  './images/dino/Idle (6).png';
import idle7 from  './images/dino/Idle (7).png';
import idle8 from  './images/dino/Idle (8).png';
import idle9 from  './images/dino/Idle (9).png';
import idle10 from  './images/dino/Idle (10).png';
import walk1 from './images/dino/Walk (1).png'; //https://pzuh.itch.io/free-dino-sprites
import walk2 from  './images/dino/Walk (2).png';
import walk3 from  './images/dino/Walk (3).png';
import walk4 from './images/dino/Walk (4).png';
import walk5 from  './images/dino/Walk (5).png';
import walk6 from  './images/dino/Walk (6).png';
import walk7 from  './images/dino/Walk (7).png';
import walk8 from  './images/dino/Walk (8).png';
import walk9 from  './images/dino/Walk (9).png';
import walk10 from  './images/dino/Walk (10).png';
import dino1 from './images/dino/Run (1).png'; //https://pzuh.itch.io/free-dino-sprites
import dino2 from  './images/dino/Run (2).png';
import dino3 from  './images/dino/Run (3).png';
import dino4 from './images/dino/Run (4).png';
import dino5 from  './images/dino/Run (5).png';
import dino6 from  './images/dino/Run (6).png';
import dino7 from  './images/dino/Run (7).png';
import dino8 from  './images/dino/Run (8).png';
import jump1 from './images/dino/Jump (1).png'; //https://pzuh.itch.io/free-dino-sprites
import jump2 from  './images/dino/Jump (2).png';
import jump3 from  './images/dino/Jump (3).png';
import jump4 from './images/dino/Jump (4).png';
import jump5 from  './images/dino/Jump (5).png';
import jump6 from  './images/dino/Jump (6).png';
import jump7 from  './images/dino/Jump (7).png';
import jump8 from  './images/dino/Jump (8).png';
import jump9 from  './images/dino/Jump (9).png';
import jump10 from  './images/dino/Jump (10).png';
import jump11 from  './images/dino/Jump (11).png';
import jump12 from  './images/dino/Jump (12).png';
import dead1 from './images/dino/Dead (1).png'; //https://pzuh.itch.io/free-dead-sprites
import dead2 from  './images/dino/Dead (2).png';
import dead3 from  './images/dino/Dead (3).png';
import dead4 from './images/dino/Dead (4).png';
import dead5 from  './images/dino/Dead (5).png';
import dead6 from  './images/dino/Dead (6).png';
import dead7 from  './images/dino/Dead (7).png';
import dead8 from  './images/dino/Dead (8).png';

import { playKeypressSound, playJumpSound, playCrashSound } from './sounds';

export default class Player extends React.Component {

  constructor(props) {
    super(props);
    this.player = React.createRef();
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.state = { 
      yPos:15, /*position from bottom*/
      up:true, /*false to go up, true to go back down to 0*/
      jumping:false, /*prevents multiple jumps before animation finishes*/
      running:false,
      idle:true,
      walking:false,
      dead:false,
      dinoImg:idle1,
      updateDino:null,
      correctIndex:0,
      spaceJump:false,
    };
    this.dinoRun = this.dinoRun.bind(this)
    this.dinoJump = this.dinoJump.bind(this)
    this.dinoDead = this.dinoDead.bind(this)
  }

  handleKeyDown(e) {
    //e.preventDefault() //may use, but stops refresh and everything...
    if (!this.props.moving) {
      this.props.getMoving();
    }
    //changes from idle to walking at start
    if (!this.state.jumping && !this.state.dead) {
      this.setState({idle:false, running:true, walking:false})
    }
    
    //handle sound
    if (this.props.playing && this.props.speakerOn === 'on') {
      playKeypressSound()
    }

    let textLen = this.props.text.length;
    let keyCode = this.props.text.charCodeAt(this.state.correctIndex)

    if (textLen > 1) { //words (jump on space after word)
      if (e.keyCode === keyCode) {
        if (this.state.correctIndex < textLen) {
          document.getElementById('text_'+this.state.correctIndex).style.color = 'green';
          this.setState({correctIndex:this.state.correctIndex + 1}) 
        }
      }
      if (e.keyCode === 32 && this.state.correctIndex === textLen && !this.state.jumping) {
        this.jump()
      }
    } else { //single letter (jump on correct keypress)
      if (e.keyCode === keyCode ) {
        document.getElementById('text_0').style.color = 'green';
        if (!this.state.jumping) {
          this.jump()
        } 
      }       
    }
  }


  jump () {
    this.setState({jumping:true, running:false, idle:false})
    this.props.increaseJumpCount()
    this.props.speakerOn === 'on' && playJumpSound()
    this.dinoJump()
    let start;
    let last;
    let denom = .85 * this.props.speed //allows jump to animate faster as speed increases
    //console.log('speed ' + this.props.speed) //debug for testing speed during gameplay

    let step = (timestamp) =>  {
      this.props.getPlayerY(this.state.yPos)
      let finished = false;
      if (start === undefined) {
        start = timestamp;
        last = timestamp;
      }

      const frameTime = timestamp - last
      //console.log('ft ' + frameTime) //should be about 16.7

      if (this.state.up) {
        this.setState((state, props) => ({
          yPos: this.state.yPos + (frameTime / denom ) //2.5 good initial speed
        }));        
      } else {
        if (this.state.yPos <= 15) {
        this.setState((state, props) => ({
          yPos: 15,
          up: true,
          jumping:false,
          idle:false,
          running:true
        }));
        finished = true;
        } else {
          this.setState((state, props) => ({
            yPos: this.state.yPos - (frameTime / denom ) //2.5 good initial speed
          })); 
        }   
      }

      if (this.state.yPos >= 250) {
        this.setState({up:false})
      }

      last = timestamp;
      
      if (!this.state.dead && this.props.playing && !finished){
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step); 

  }

  dinoRun () {
    if (this.state.running) {
      if (this.state.dinoImg === dino1) {
        this.setState({dinoImg:dino2})
      } else if (this.state.dinoImg === dino2) {
        this.setState({dinoImg:dino3})      
      } else if (this.state.dinoImg === dino3) {
        this.setState({dinoImg:dino4})      
      } else if (this.state.dinoImg === dino4) {
        this.setState({dinoImg:dino5})      
      } else if (this.state.dinoImg === dino5) {
        this.setState({dinoImg:dino6})      
      } else if (this.state.dinoImg === dino6) {
        this.setState({dinoImg:dino7})      
      } else if (this.state.dinoImg === dino7) {
        this.setState({dinoImg:dino8})      
      } else if (this.state.dinoImg === dino8) {
        this.setState({dinoImg:dino1})      
      } else {
        this.setState({dinoImg:dino1})      
      }      
    } else if (this.state.idle) {
      if (this.state.dinoImg === idle1) {
        this.setState({dinoImg:idle2})
      } else if (this.state.dinoImg === idle2) {
        this.setState({dinoImg:idle3})      
      } else if (this.state.dinoImg === idle3) {
        this.setState({dinoImg:idle4})      
      } else if (this.state.dinoImg === idle4) {
        this.setState({dinoImg:idle5})      
      } else if (this.state.dinoImg === idle5) {
        this.setState({dinoImg:idle6})      
      } else if (this.state.dinoImg === idle6) {
        this.setState({dinoImg:idle7})      
      } else if (this.state.dinoImg === idle7) {
        this.setState({dinoImg:idle8})      
      } else if (this.state.dinoImg === idle8) {
        this.setState({dinoImg:idle9})      
      } else if (this.state.dinoImg === idle9) {
        this.setState({dinoImg:idle10})      
      } else if (this.state.dinoImg === idle10) {
        this.setState({dinoImg:idle1})      
      } 
      else {
        this.setState({dinoImg:idle1})      
      }
    } else if (this.state.walking) {
      if (this.state.dinoImg === walk1) {
        this.setState({dinoImg:walk2})
      } else if (this.state.dinoImg === walk2) {
        this.setState({dinoImg:walk3})      
      } else if (this.state.dinoImg === walk3) {
        this.setState({dinoImg:walk4})      
      } else if (this.state.dinoImg === walk4) {
        this.setState({dinoImg:walk5})      
      } else if (this.state.dinoImg === walk5) {
        this.setState({dinoImg:walk6})      
      } else if (this.state.dinoImg === walk6) {
        this.setState({dinoImg:walk7})      
      } else if (this.state.dinoImg === walk7) {
        this.setState({dinoImg:walk8})      
      } else if (this.state.dinoImg === walk8) {
        this.setState({dinoImg:walk9})      
      } else if (this.state.dinoImg === walk9) {
        this.setState({dinoImg:walk10})      
      } else if (this.state.dinoImg === walk10) {
        this.setState({dinoImg:walk1})      
      } 
      else {
        this.setState({dinoImg:walk1})      
      }      
    }

    
  }

  dinoJump () {
    let inc = this.props.speed * 18 //animates faster as speed increases
    let getImg = () => {
      if (!this.state.dead) { //stops loop from chaning images (jerky animation) if dead
        if (this.state.dinoImg === jump1) {
          this.setState({dinoImg:jump2})
        } else if (this.state.dinoImg === jump2) {
          this.setState({dinoImg:jump3})      
        } else if (this.state.dinoImg === jump3) {
          this.setState({dinoImg:jump4})      
        } else if (this.state.dinoImg === jump4) {
          this.setState({dinoImg:jump5})      
        } else if (this.state.dinoImg === jump5) {
          this.setState({dinoImg:jump6})      
        } else if (this.state.dinoImg === jump6) {
          this.setState({dinoImg:jump7})      
        } else if (this.state.dinoImg === jump7) {
          this.setState({dinoImg:jump8})      
        } else if (this.state.dinoImg === jump8) {
          this.setState({dinoImg:jump9})      
        } else if (this.state.dinoImg === jump9) {
          this.setState({dinoImg:jump10})      
        } else if (this.state.dinoImg === jump10) {
          this.setState({dinoImg:jump11})      
        } else if (this.state.dinoImg === jump11) {
          this.setState({dinoImg:jump12})      
        } else if (this.state.dinoImg === jump12) {
          this.setState({dinoImg:jump1})      
        }
        else {
          this.setState({dinoImg:jump1})      
        } 
      }
    }
    //https://brackets.clementng.me/post/24150213014/example-of-a-javascript-closure-settimeout-inside#:~:text=Text%20Example%20of%20a%20Javascript%20Closure%3A%20setTimeout%20Inside,if%20we%20didn%E2%80%99t%20fully%20understand%20how%20they%20work.
    for (var i = 0; i <= 11; i++) {
        setTimeout(function(x) { return function() { getImg(); }; }(i), i * inc)//80);
    }
  }

  dinoDead () {
    let inc = this.props.speed * 25 //animates faster as speed increases
    let getImg = () => {
      if (this.state.dinoImg === dead1) {
        this.setState({dinoImg:dead2})
      } else if (this.state.dinoImg === dead2) {
        this.setState({dinoImg:dead3})      
      } else if (this.state.dinoImg === dead3) {
        this.setState({dinoImg:dead4})      
      } else if (this.state.dinoImg === dead4) {
        this.setState({dinoImg:dead5})      
      } else if (this.state.dinoImg === dead5) {
        this.setState({dinoImg:dead6})      
      } else if (this.state.dinoImg === dead6) {
        this.setState({dinoImg:dead7})      
      } else if (this.state.dinoImg === dead7) {
        this.setState({dinoImg:dead8})      
      } 
      else {
        this.setState({dinoImg:dead1})      
      }
    }
    //https://brackets.clementng.me/post/24150213014/example-of-a-javascript-closure-settimeout-inside#:~:text=Text%20Example%20of%20a%20Javascript%20Closure%3A%20setTimeout%20Inside,if%20we%20didn%E2%80%99t%20fully%20understand%20how%20they%20work.
    for (var i = 0; i <= 7; i++) {
        setTimeout(function(x) { return function() { getImg(); }; }(i), i * inc);//100);
    }    
  }


  componentDidMount() {
    if (this.props.menu !== true) { //ignore keydown on menu
      window.addEventListener('keydown', this.handleKeyDown);      
    }

    this.setState({updateDino:setInterval(this.dinoRun,100)})

    let player = document.getElementById("player");
    if (this.props.showMenu) {
      this.setState({idle:false,walking:true})
      player.className = "walk"; 
    } else {
      player.classList.remove('walk');
    }

  }

  componentDidUpdate(prevProps){
    if(prevProps.playing && !this.props.playing) {
        clearInterval(this.state.updateDino)
        this.props.speakerOn === 'on' && playCrashSound()
        this.setState({dead:true, jumping:false, running:false, idle:false, walking:false,})
        this.dinoDead()
    }
    if (this.props.text !== prevProps.text && prevProps.text !== '') {
      this.setState({correctIndex:0, spaceJump:false}) //new word, reinitializes for jumping
    }
  }


  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    clearInterval(this.state.updateDino)
  }

  render() {
    return (
      <img id="player" src={this.state.dinoImg} tabIndex="0" ref={this.player}  style={{bottom : this.state.yPos}} alt="dino"/>
    );
  }
}
